import { ErrorBoundary } from "@sentry/react";
import {
  createFileRoute,
  Outlet,
  redirect,
  useLocation,
} from "@tanstack/react-router";
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/wb/AppSidebar";
import { Fallback } from "@/components/wb/Fallback";

export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ context, location }) => {
    const { isAuthenticated } = context.auth;
    if (!isAuthenticated) {
      throw redirect({
        to: "/login",
        search: {
          next: location.href,
        },
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const location = useLocation();

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <ErrorBoundary key={location.pathname} fallback={Fallback}>
          <Outlet />
        </ErrorBoundary>
      </SidebarInset>
    </SidebarProvider>
  );
}
